import React from 'react';

const GallerySection = () => {
  // ギャラリー画像のURL
  const galleryImages = [
    {
      url: 'https://customer-assets.emergentagent.com/job_design-carousel-2/artifacts/ob59ojuo_tbrender_006.png',
      alt: 'ジュースパック 3Dモックアップ'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_design-carousel-2/artifacts/zih64brn_Headphone_Main%20Camera.png',
      alt: 'ヘッドフォン 3Dモックアップ'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_design-carousel-2/artifacts/hg5yq1pd_tbrender%281%29.png',
      alt: '化粧品チューブ 3Dモックアップ'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_design-carousel-2/artifacts/rduxiryl_waterbottle3.png',
      alt: 'ウォーターボトル 3Dモックアップ'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_design-carousel-2/artifacts/63hhczsk_ScrewDriver_004.png',
      alt: 'スクリュードライバー 3Dモックアップ'
    }
  ];

  // 画像を2回繰り返して無限スクロール効果を作成
  const duplicatedImages = [...galleryImages, ...galleryImages];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-gray-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <div className="text-center">
          <h2 className="text-4xl lg:text-6xl font-black text-gray-900 mb-4 font-din tracking-tight">
            {/* <span className="text-transparent bg-gradient-to-r from-blue-600 to-green-500 bg-clip-text"> */}
            <span className="text-transparent bg-gradient-to-r from-blue-600 to-green-500 bg-clip-text py-3 px-2">ギャラリー</span>
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            これまでに制作した3Dモックアップの一部をご紹介します
          </p>
        </div>
      </div>

      {/* スクロールコンテナ */}
      <div className="relative w-full">
        {/* 左右のグラデーションオーバーレイ */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-slate-50 to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-gray-100 to-transparent z-10 pointer-events-none"></div>

        {/* スクロールアニメーションコンテナ */}
        <div className="gallery-scroll-container flex gap-8">
          {/* 最初のセット */}
          <div className="gallery-scroll flex gap-8 items-center">
            {duplicatedImages.map((image, index) => (
              <div
                key={`image-${index}`}
                className="flex-shrink-0 w-[28rem] h-[28rem] bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 p-10 flex items-center justify-center"
              >
                <img
                  src={image.url}
                  alt={image.alt}
                  className="max-w-full max-h-full object-contain"
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          {/* 2番目のセット（シームレスな無限ループ用） */}
          <div className="gallery-scroll flex gap-8 items-center">
            {duplicatedImages.map((image, index) => (
              <div
                key={`image-duplicate-${index}`}
                className="flex-shrink-0 w-[28rem] h-[28rem] bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 p-10 flex items-center justify-center"
              >
                <img
                  src={image.url}
                  alt={image.alt}
                  className="max-w-full max-h-full object-contain"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        .gallery-scroll-container {
          animation: scroll-left 20s linear infinite;
        }

        @keyframes scroll-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .gallery-scroll-container:hover {
          animation-play-state: paused;
        }

        @media (max-width: 768px) {
          .gallery-scroll-container {
            animation-duration: 13s;
          }
        }
      `}</style>
    </section>
  );
};

export default GallerySection;
